import { IFileIdAndOwner, IFileToPathConverter } from '../interfaces/ifiletopathconverter';

export class LocalFileFileToPathConverter implements IFileToPathConverter {
  convert(file: IFileIdAndOwner): string[] {
    if (!file?.path) {
      throw new Error('Expected local file with path');
    }
    return file.path;
  }
}
